/**
 * Ce module comprend des constantes nécessaires pour les appels à l'API PHP de l'authentification et
 * pour afficher les questionnaires une fois l'utilisateur authentifié.
 * 
 * @author Francis Chabot
 * @module UrlApi
 * 
 * @since 0.1.0
 */
const URL_ENV = {
    test: 'https://information.stat.gouv.qc.ca/',
    devl: '/',
    unit: 'https://collecteweb.isq-unit.stat/',
    fonc: 'https://collecteweb.isq-fonc.stat/',
    accp: 'https://collecteweb.isq-accp.stat/',
    prod: 'https://collecteweb.isq-prod.stat/',
    diff: 'https://collecteweb.stat.gouv.qc.ca/'
}

/**
 * Url de l'API.
 * 
 * @constant {String} URL_API
 */
export const URL_API = URL_ENV[process.env.REACT_APP_ENV] + 'api/';

/**
 * Url des questionnaires.
 * 
 * @constant {String} URL_QUEST
 */
export const URL_QUEST = URL_ENV[process.env.REACT_APP_ENV] + 'questionnaire/';